var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _path10, _path11, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SecurityGuardSkinType350(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M28.996,32h-5h-5c0,0-11.009,2.344-11,13h32C40.183,34.594,28.996,32,28.996,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc8f00",
    d: "M23.996,33l-5-1v-6h10v6L23.996,33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc8f00",
    d: "M34.996,20c0,1.105-0.895,2-2,2c-1.104,0-2-0.895-2-2s0.896-2,2-2 C34.101,18,34.996,18.895,34.996,20 M16.996,20c0-1.105-0.895-2-2-2s-2,0.895-2,2s0.895,2,2,2S16.996,21.105,16.996,20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa45",
    d: "M32.996,14c0-7.635-18-4.971-18,0v7c0,4.971,4.029,9,9,9c4.972,0,9-4.029,9-9V14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#795548",
    d: "M23.996,5c-6.075,0-10,4.926-10,11v2.286l2,1.714v-5l12-0.75l4,0.75v5l2-1.742V16 c0-4.025-1.038-8.016-6-9l-1-2H23.996z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M26.996,20c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S26.996,20.551,26.996,20 M18.996,20 c0,0.551,0.448,1,1,1s1-0.449,1-1s-0.448-1-1-1S18.996,19.449,18.996,20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M36.862,9.199C36.105,11.141,33.996,13,33.996,13s-2.373-2.492-9.999-2.492 C16.369,10.508,13.996,13,13.996,13s-2.108-1.859-2.864-3.801c-0.13-0.332-0.394-0.928,0.554-1.094C18.073,6.981,21.627,2,23.997,2 c3.554,0,5.923,4.981,12.31,6.106C37.255,8.271,36.991,8.867,36.862,9.199z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M38.996,36l-9-3.75v4l9,3.75V36z M8.996,40l9-3.75v-4l-9,3.75L8.996,40z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f51b5",
    points: "22.996,36 21.996,35 23.996,33 25.996,35 24.996,36 25.996,45 21.996,45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M13.996,13v2h20v-2c0,0-2.373-2.492-9.999-2.492C16.369,10.508,13.996,13,13.996,13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M33.996,14.998c0,0-1.76,3.002-9.999,3.002c-8.24,0-10.001-3.002-10.001-3.002S16.845,13,23.997,13 C31.148,13,33.996,14.998,33.996,14.998z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M25.996,5.961c0,0-0.895-0.961-2-0.961c-1.104,0-2,0.961-2,0.961c0,1.105,0.897,3.039,2,3.039 C25.101,9,25.996,7.066,25.996,5.961z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 11.996,
    y: 42,
    fill: "#3f51b5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 29.996,
    y: 42,
    fill: "#3f51b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SecurityGuardSkinType350);
export default __webpack_public_path__ + "static/media/icons8-security-guard-skin-type-3-50.8906a7bcb9046cc35e5ba70b951eeb7a.svg";
export { ForwardRef as ReactComponent };